import { CheckoutRoute } from "@swiggy-private/checkout-types";

// possible initial checkout state
export enum CHECKOUT_INITIAL_STATE {
    DIRECT_PLACE_ORDER = "DIRECT_PLACE_ORDER",
    CONFIRM_ORDER = "CONFIRM_ORDER",
    WALLET_MONEY_RECEIVED = "WALLET_MONEY_RECEIVED",
    PAYMENTS = "PAYMENTS",
    CART = "CART",
    PAYLATER_SIMPL_LINKING_FAILED = "PAYLATER_SIMPL_LINKING_FAILED",
    PAYLATER_SIMPL_LINKING_SUCCESS_DONT_PROCEED_WITH_ORDER = "PAYLATER_SIMPL_LINKING_SUCCESS_DONT_PROCEED_WITH_ORDER",
    PAYLATER_SIMPL_LINKING_SUCCESS_PROCEED_WITH_ORDER = "PAYLATER_SIMPL_LINKING_SUCCESS_PROCEED_WITH_ORDER",
    SHARED_CART = "SHARED_CART",
    GIFTING_CART = "GIFTING_CART",
    MRO_FOOD_CART = "MRO_FOOD_CART",
    QUICK_CHECKOUT = "QUICK_CHECKOUT",
}

export interface InitialCheckoutRoute {
    name: CheckoutRoute;
    data?: any;
}
